module.exports = __webpack_public_path__ + "img/ceramic-tiles.446312ad.jpg";